import React from 'react';
import { Box } from '@mui/material';

function ResponsivePageSection({ children, sx = {} }) {
  return (
    <Box
      sx={{
        px: { xs: 0, sm: 0 },
        width: '100%',
        overflowX: 'hidden',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export default ResponsivePageSection;
